import script from "./SvgBackGround.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgBackGround.vue?vue&type=script&setup=true&lang=ts"

import "./SvgBackGround.vue?vue&type=style&index=0&id=0640197c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0640197c"]])

export default __exports__